import React from 'react';
import type { CampaignInfoSuffixProps } from '../CampaignInfoSuffixRegistry';
import styles from './ClaimedWinCurrency.module.css';

const ClaimedWinCurrency: React.FC<CampaignInfoSuffixProps> = (props) => {
  if (!props.suffix) return null;

  return (
    <span className={styles.currency} {...props.attributes}>
      {props.suffix}
    </span>
  );
};

export default ClaimedWinCurrency;
